import { useSyncExternalStore } from "react";
import {
  getDocumentScopeMode,
  subscribeDocumentScopeMode,
  type DocumentScopeMode,
} from "@/features/settings/api/documentScopePreference";

/**
 * The current "lead document or deal document?" answer this user has asked
 * Xale to remember. Re-renders every reader when it changes, so ticking
 * "Remember my choice" in the upload prompt and the Settings → Manage control
 * always agree without either one owning the state.
 */
export function useDocumentScopeMode(): DocumentScopeMode {
  return useSyncExternalStore(subscribeDocumentScopeMode, getDocumentScopeMode);
}
